module.exports = __webpack_public_path__ + "static/img/认证1.9270fd3a.jpg";